import React from 'react';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as RemapIcon } from '../../../assets/svg/remap-svg.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/svg/download.svg';
import { ReactComponent as TickIcon } from '../../../assets/svg/expense-tick.svg';
import { ReactComponent as MoreIconNew } from '../../../assets/svg/more-icon.svg';
import { ReactComponent as FullScreen } from '../../../assets/svg/full-screen.svg';
import { ReactComponent as LinkIcon } from '../../../assets/svg/external-link.svg';
import RecordMCBackup from '../../components/modals/projects/recordMCBackup';
import RecordMemCardBackup from '../../components/modals/projects/recordMemCardBackup';
import ReAssignMemoryCards from '../../components/modals/projects/reAssignMemoryCards';
import MCTableFullScreen from './MCTableFullScreen';
import CreateExpense from '../../components/modals/projects/createExpense';
import CreateShoot from '../../components/modals/projects/createShoot';
import { ReactComponent as CrossIcon3 } from '../../../assets/svg/cross3.svg';
import moment from 'moment';
import _ from 'lodash';
import { withRouter } from '../../../services/withRoute';
import EqTableFullScreen from './EqTableFullScreen';
import { ReactComponent as CrossIcon } from '../../../assets/svg/cross.svg';
import { ReactComponent as CrossIcon2 } from '../../../assets/svg/white-cross.svg';
const getEvent = gql`
	query VendorEvent($projectId: ID!, $workspaceId: String!, $vendorEventId: ID!) {
		vendorEvent(projectId: $projectId, workspaceId: $workspaceId, id: $vendorEventId) {
			id
			projectId
			name
			projectSlNo
			slNo
			additionalServices {
				type
				priceInRupees
				_id
			}
			crew {
				count
				role
				managerIds
				subRole
				userIds
			}
			crewNew {
				userId
				roles {
					role
					subRole
				}
				isManager
				isCustomUser
			}
			venue
			date
			reportingTime
			projectTitle
			city
			tenantId
			equipments {
				eqId
				qrCode
				status
				isReceived
				userId
				description
				manufacturerId
				createdBy {
					id
					name
				}
				receivedBy {
					name
					id
				}
				userName
				receivedFrom {
					name
				}
				receivedAt
				createdAt
				branch {
					_id
					branchId
				}
			}
			unregisteredEqs {
				_id
				status
				manufacturerId
				isReceived
				createdAt
				receivedAt
				description
				quantity
				receivedQuantity
				id
				receivedBy {
					id
					name
				}
				createdBy {
					id
					name
				}
				userId
				userName
			}
			hardDrives {
				_id
				qrCode
				category
				isPurchasedByClient
				status
				size
			}
			memoryCards {
				mcId
				qrCode
				createdAt
				createdBy {
					id
					name
				}
				manufacturerId
				type
				size
				ownerId
				userId
				userName
				status
				isReceived
				isEmpty
				isRemapped
				receivedFrom {
					id
					name
				}
				receivedBy {
					id
					name
				}
				releasedBy {
					name
				}
				releasedAt
				receivedAt
				backupLogs {
					backupLogId
					verifyLogId
					hddId
					hddQrCode
					backupSize
					backupPath
					numberOfFiles
					createdBy {
						id
						name
					}
					isVerified
					logId
					verifiedBy {
						id
						name
					}
					files {
						_id
						fileType
						originalFileName
						s3KeyOriginal
						originalFileSizeInMb
					}
				}
				subStatus
			}
			expenses {
				_id
				amount
				billDate
				billTo
				currency
				type
			}
		}
	}
`;

const getOnlyMCLogs = gql`
	query VendorEvent($projectId: ID!, $vendorEventId: ID!, $workspaceId: String!) {
		vendorEvent(projectId: $projectId, id: $vendorEventId, workspaceId: $workspaceId) {
			memoryCards {
				mcId
				qrCode
				createdAt
				createdBy {
					id
					name
				}
				manufacturerId
				type
				size
				ownerId
				userId
				userName
				status
				isReceived
				isEmpty
				isRemapped
				receivedFrom {
					id
					name
				}
				receivedBy {
					id
					name
				}
				receivedAt
				backupLogs {
					backupLogId
					verifyLogId
					hddId
					hddQrCode
					backupSize
					backupPath
					numberOfFiles
					createdBy {
						id
						name
					}
					isVerified
					logId
					verifiedBy {
						id
						name
					}
					files {
						_id
						fileType
						originalFileName
						s3KeyOriginal
						originalFileSizeInMb
					}
				}
				subStatus
			}
		}
	}
`;

const getEventMCLogs = gql`
	query EventMcLogSummary($eventId: ID!) {
		eventMcLogSummary(eventId: $eventId) {
			isReceived
			backupLogs {
				createdBy {
					_id
					name
				}
				hddQrCode
				hddId
				isVerified
				verifiedBy {
					_id
					name
				}
				backupSize
				backupPath
				files {
					_id
					fileType
					originalFileName
					s3KeyOriginal
					originalFileSizeInMb
				}
			}
			qrCode
			userName
			userId
			status
			manufacturerId
			type
			size
		}
	}
`;
//tenantUsersList
// const getTenantUsersList = gql`
// 	query TenantUsersList($workspaceIds: [String!]!) {
// 		tenantUsersList(workspaceIds: $workspaceIds) {
// 			id
// 			firstName
// 			lastName
// 			email
// 			isEmailVerified
// 			phoneNumber
// 			isShooter
// 			isSuspended
// 			displayName
// 		}
// 	}
// `;
const getExpenses = gql`
	query VendorExpenses($filters: expenseFiltersInput) {
		vendorExpenses(filters: $filters) {
			id
			projectId
			amount
			type
			billDate
			billTo
			metaData
			projectDetails {
				_id
				title
			}
			eventId
			approvedBy {
				userId
				userName
			}
			spentBy
			isApproved
			isRejected
			isDeleted
		}
	}
`;
const getTenantUsers = gql`
	query VendorUsers {
		vendorUsers {
			id
			firstName
			lastName
			email
			isEmailVerified
			phoneNumber
			isShooter
			isSuspended
			displayName
			isFreelancer
			skillLevel {
				candidCinematography
				candidPhotography
				leadership
				traditionalPhotography
				traditionalVideography
			}
			accessibleTenants {
				role
				tenant_id
				walletBalance
				workspaceId
			}
			accessibleBranches {
				_id
				branchId
			}
		}
	}
`;
class NewShoot extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			isVendorUsersLoading: true,
			projectDetails: {},
			eventDetails: {},
			shootEditType: null,
			showEventModal: false,
			showEventModal2: false,
			showEquimentDropdown: false,
			showEquimentAssignModal: false,
			showEquimentReceiveModal: false,
			showMemoryCardDropdown: false,
			showMemoryCardAssignModal: false,
			showMemoryCardReceiveModal: false,
			showReAssignEquipments: false,
			showEventDropdown: false,
			expensesList: {},
			mcFilterList: {},
			mcCurrFilter: 'All',
			mcSearchQuery: '',
			eqCurrFilter: 'All',
			mcFilterList: {},
			showRecordMCModal: false,
			selectedMC: null,
			showRecordABackUpModal: false,
			showReAssignMemoryCards: false,
			showAddEditExpenseModal: false,
			showShootAddEditModal: false,
			activeExpenseID: null,
			// cp: [],
			// tp: [],
			// cv: [],
			// tv: [],
		};
		this.eventRef = React.createRef();
		this.eventDropDownRef = React.createRef();
		this.equipmentRef = React.createRef();
		this.equipmentDropdownRef = React.createRef();
		this.memoryCardRef = React.createRef();
		this.memoryCardDropdownRef = React.createRef();
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
		let filters = {
			projectId: this.props.params.projectID,
			vendorEventId: this.props.params.shootID,
			workspaceId: this.props.params.workspaceID,
		};

		let filters2 = {
			workspaceIds: [this.props.params.workspaceID],
		};
		let json = {
			filters: {
				eventId: this.props.params.shootID,
				projectId: this.props.params.projectID,
			},
		};

		await this.getExpenses(getExpenses, json);
		await this.getShootInfo(getEvent, filters);
		await this.getTenantUsers(getTenantUsers);
	};
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.hanckOutside);
	}

	eventDetailsUpdated = async () => {
		this.setState(
			{
				isLoading: true,
			},
			async () => {
				let filters = {
					projectId: this.props.params.projectID,
					vendorEventId: this.props.params.shootID,
					workspaceId: this.props.params.workspaceID,
				};

				let json = {
					filters: {
						eventId: this.props.params.shootID,
						projectId: this.props.params.projectID,
					},
				};
				await this.getExpenses(getExpenses, json);
				await this.getShootInfo(getEvent, filters);
			},
		);
	};
	mcOnChangeFIlter = (key) => {
		this.setState({
			mcCurrFilter: key,
		});
	};
	handleOnCLickMC = (mc) => {
		// if (
		// 	mc.status === 'backupPending' ||
		// 	mc.status === 'verificationPending' ||
		// 	mc.status === 'formatPending'
		// ) {
		this.setState({
			showRecordMCModal: true,
			selectedMC: mc,
		});
		// }
	};

	handleOnClickHDD = (el) => {
		this.props.navigate(`/${this.props.params.vendorID}/harddrives/${el.qrCode}`);
	};
	showRecordMCModal = (e) => {
		this.setState({
			showRecordMCModal: !this.state.showRecordMCModal,
		});
	};
	mcDetailsUpdated = (isWithoutLoading = null) => {
		let getEventMCLogsVariables = {
			vendorEventId: this.props.params.shootID,
			projectId: this.props.params.projectID,
			workspaceId: this.props.params.workspaceID,
		};
		this.getEventMemoryCardLogs(getOnlyMCLogs, getEventMCLogsVariables, isWithoutLoading);
	};

	getAllCrewNames(role, subrole) {
		let temparray = '';
		if (this.state.eventDetails && this.state.eventDetails.crewNew) {
			_.forEach(this.state.eventDetails.crewNew, (crew) => {
				if (crew.isCustomUser !== true) {
					let found = undefined;
					found = _.find(this.state.tenantUsersList, { id: crew.userId });
					_.forEach(crew.roles, (roles) => {
						if (roles.role === role && roles.subRole === subrole) {
							if (found !== undefined) {
								temparray += found.displayName
									? found.displayName + ' '
									: found.firstName + ' ' + found.lastName + ' ';
								temparray += crew.isManager ? '(SM)' : '';
								temparray += found.phoneNumber
									? ' (' + found.phoneNumber + ')'
									: '';

								temparray += ',';
							} else if (crew.userId === null) {
								temparray += 'unassigned';
								temparray += ',';
							}
						}
					});
				}
			});
		}

		return temparray === '' ? '-' : temparray.substring(0, temparray.length - 1);
	}

	goBack = (e) => {
		this.props.navigate(-1);
	};
	handleClickOutside = (event) => {
		if (
			this.equipmentRef.current &&
			!this.equipmentRef.current.contains(event.target) &&
			this.equipmentDropdownRef.current &&
			!this.equipmentDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showEquimentDropdown: false,
			});
		}
		if (
			this.memoryCardRef.current &&
			!this.memoryCardRef.current.contains(event.target) &&
			this.memoryCardDropdownRef.current &&
			!this.memoryCardDropdownRef.current.contains(event.target)
		) {
			this.setState({
				showMemoryCardDropdown: false,
			});
		}
	};
	getNotReceivedCount = () => {
		let c = 0;
		if (this.state.eventDetails.memoryCards) {
			for (let i = 0; i < _.size(this.state.eventDetails.memoryCards); i++) {
				if (this.state.eventDetails.memoryCards[i].isReceived === false) {
					c += 1;
				}
			}
		}

		return c;
	};

	getNotReceivedCount2 = (equipments) => {
		let c = 0;
		if (equipments) {
			for (let i = 0; i < _.size(equipments); i++) {
				if (equipments[i].isReceived === false) {
					c += 1;
				}
			}
		}

		return c;
	};
	toggleEquipmentDropDown = (e) => {
		this.setState({
			showEquimentDropdown: !this.state.showEquimentDropdown,
		});
	};
	showEquimentAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-equipment`,
		);
	};

	showEquimentReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-equipment`,
		);
	};
	toggleMemoryCardDropDown = (e) => {
		this.setState({
			showMemoryCardDropdown: !this.state.showMemoryCardDropdown,
		});
	};
	showMemoryCardAssignModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/assign-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardAssignModal: !this.state.showMemoryCardAssignModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardAssignModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showMemoryCardReceiveModal = (e) => {
		this.props.navigate(
			`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}/receive-memory-card`,
		);
		// this.setState(
		// 	{
		// 		showMemoryCardReceiveModal: !this.state.showMemoryCardReceiveModal,
		// 	},
		// 	() => {
		// 		if (this.state.showMemoryCardReceiveModal === false) {
		// 			this.handleReload();
		// 		}
		// 	},
		// );
	};
	showRecordABackUpModal = (e) => {
		this.setState({
			showRecordABackUpModal: !this.state.showRecordABackUpModal,
		});
	};
	showReAssignMemoryCards = (e) => {
		this.setState({
			showReAssignMemoryCards: !this.state.showReAssignMemoryCards,
		});
	};

	showReAssignEquipments = (e) => {
		this.setState({
			showReAssignEquipments: !this.state.showReAssignEquipments,
		});
	};
	getTotalExpenseAmount = () => {
		let tot = 0;
		if (this.state.expensesList && _.size(this.state.expensesList) !== 0) {
			for (let i = 0; i < _.size(this.state.expensesList); i++) {
				tot += this.state.expensesList[i].amount;
			}
		}
		return tot;
	};
	toggleEventDropdown = (e) => {
		this.setState({
			showEventDropdown: !this.state.showEventDropdown,
		});
	};
	toggleModal = () => {
		this.setState({
			showEventModal: !this.state.showEventModal,
		});
	};
	eqOnChangeFIlter = (key) => {
		this.setState({
			eqCurrFilter: key,
		});
	};
	onExpandClick = () => {
		this.setState({
			showEventModal: true,
		});
	};
	toggleModal2 = () => {
		this.setState({
			showEventModal2: !this.state.showEventModal2,
		});
	};
	onExpandClick2 = () => {
		this.setState({
			showEventModal2: true,
		});
	};

	isVerfiedResult = (backuplogArray) => {
		if (_.size(backuplogArray) !== 0 && backuplogArray !== null) {
			for (let i = 0; i < _.size(backuplogArray); i++) {
				if (backuplogArray[i].isVerified === false) {
					return false;
				}
			}
			return true;
		}
		return false;
	};
	getAllAssignedToNames = () => {
		let arr = [];
		let newArr = [];
		if (this.state.eventDetails.memoryCards) {
			for (let i = 0; i < _.size(this.state.eventDetails.memoryCards); i++) {
				if (!arr.includes(this.state.eventDetails.memoryCards[i].userName)) {
					arr.push(this.state.eventDetails.memoryCards[i].userName);
				}
			}
			for (let i = 0; i < arr.length; i++) {
				let tc = 0;
				let rc = 0;
				for (let j = 0; j < _.size(this.state.eventDetails.memoryCards); j++) {
					if (this.state.eventDetails.memoryCards[j].userName === arr[i]) {
						tc += 1;
						if (this.state.eventDetails.memoryCards[j].isReceived === true) {
							rc += 1;
						}
					}
				}
				newArr.push({ name: arr[i], tc: tc, rc: rc });
			}
		}

		return newArr;
	};
	formatCurrency = (type, number) => {
		switch (type) {
			case 'inr':
				return new Intl.NumberFormat('en-IN', {
					maximumFractionDigits: 0,
					minimumFractionDigits: 0,
				}).format(number);
			case 'usd':
				return new Intl.NumberFormat('en-US', {
					maximumFractionDigits: 0,
					minimumFractionDigits: 0,
				}).format(number);
			default:
				return number;
		}
	};
	getSpentByName = (userId) => {
		if (this.state.tenantUsersList) {
			for (let i = 0; i < _.size(this.state.tenantUsersList); i++) {
				if (this.state.tenantUsersList[i].id === userId) {
					return this.state.tenantUsersList[i].displayName
						? this.state.tenantUsersList[i].displayName
						: this.state.tenantUsersList[i].firstName +
								' ' +
								this.state.tenantUsersList[i].lastName;
				}
			}
		}
		return '';
	};
	getTotalAmount = (arr) => {
		let tot = 0;
		for (let i = 0; i < _.size(arr); i++) {
			tot += arr[i].amount;
		}
		return tot;
	};
	getAllAssignedToNames2 = () => {
		let arr = [];
		let newArr = [];
		if (this.state.eventDetails.equipments) {
			for (let i = 0; i < _.size(this.state.eventDetails.equipments); i++) {
				if (!arr.includes(this.state.eventDetails.equipments[i].userName)) {
					arr.push(this.state.eventDetails.equipments[i].userName);
				}
			}
			for (let i = 0; i < _.size(arr); i++) {
				let tc = 0;
				let rc = 0;
				for (let j = 0; j < _.size(this.state.eventDetails.equipments); j++) {
					if (this.state.eventDetails.equipments[j].userName === arr[i]) {
						tc += 1;
						if (this.state.eventDetails.equipments[j].isReceived === true) {
							rc += 1;
						}
					}
				}
				newArr.push({ name: arr[i], tc: tc, rc: rc });
			}
		}

		return newArr;
	};
	getReceivedCount = () => {
		let c = 0;
		if (
			this.state.eventDetails.memoryCards &&
			_.size(this.state.eventDetails.memoryCards) !== 0
		) {
			let arr = this.state.eventDetails.memoryCards.filter((el) => el.isReceived === true);
			c = arr.length;
		}
		return c;
	};
	getReceivedCount2 = (equipments) => {
		let c = 0;
		if (equipments && _.size(equipments) !== 0) {
			let arr = equipments.filter((el) => el.isReceived === true);
			c = arr.length;
		}
		return c;
	};

	showAddEditExpenseModal = (e, activeExpenseID = null) => {
		this.setState({
			showAddEditExpenseModal: !this.state.showAddEditExpenseModal,
			activeExpenseID: activeExpenseID,
		});
	};

	showShootAddEditModal = (e, activeShootID = null, shootEditType = null) => {
		this.setState({
			showShootAddEditModal: !this.state.showShootAddEditModal,
			activeShootID,
			shootEditType,
		});
	};

	render() {
		let unregisteredEqs = [];
		let equipmentsList = [];
		if (this.state.isLoading === false && this.state.isVendorUsersLoading === false) {
			_.map(this.state.eventDetails.unregisteredEqs, (equipment) => {
				let receivedQuantity = equipment.receivedQuantity ? equipment.receivedQuantity : 0;
				for (let index = 0; index < equipment.quantity; index++) {
					if (receivedQuantity > 0) {
						unregisteredEqs.push({ ...equipment, isReceived: true, status: 'ready' });
						receivedQuantity = receivedQuantity - 1;
					} else unregisteredEqs.push(equipment);
				}
			});

			equipmentsList = _.concat(
				this.state.eventDetails.equipments ? this.state.eventDetails.equipments : [],
				unregisteredEqs,
			);
		}

		return (
			<>
				{this.state.isLoading === true || this.state.isVendorUsersLoading === true ? (
					<>
						<LoadingBar />
					</>
				) : (
					<div
						className="shoot-main-bod"
						style={{
							width: 'calc(100vw-80px)',
							maxHeight: '100vh',
							height: '100vh',
							position: 'absolute',
							top: '0',
						}}
					>
						<div
							className="event-details-section"
							style={{
								width: '25vw',
								height: '100vh',
								maxHeight: '100vh',
								overflowY: 'scroll',
							}}
						>
							<div>
								<p
									style={{
										marginTop: '20px',
										paddingLeft: '20px',
										color: '#B0B0B0',
										fontWeight: 500,
										fontSize: '12px',
									}}
								>
									EVENT DETAILS
								</p>
								<div
									style={{
										marginTop: '15px',
										padding: '0px 20px 0px 20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
										width: '100%',
										cursor: 'pointer',
									}}
									onClick={() =>
										this.props.navigate(
											`/${this.props.params.vendorID}/shoots/${this.props.params.workspaceID}/${this.props.params.projectID}`,
										)
									}
								>
									<p
										style={{
											color: '#B0B0B0',
											fontweight: 600,
											fontSize: '11px',
										}}
									>
										CLIENT
									</p>
									<div
										style={{
											//width: '100%',
											flex: 1,
											borderBottom: '0.5px solid #4F4F4F',
											marginLeft: '4px',
											marginRight: '4px',
										}}
									></div>
									<p
										style={{
											color: 'white',
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontSize: '12px',
											width: 'fit-content',
											maxWidth: '200px',
										}}
										title={this.state.eventDetails.projectTitle}
									>
										{this.state.eventDetails.projectTitle}
										<LinkIcon
											style={{
												marginLeft: '8px',
												width: '16px',
												height: '16px',
											}}
										/>
									</p>
								</div>
								<div
									style={{
										marginTop: '10px',
										padding: '0px 20px 0px 20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<p
										style={{
											color: '#B0B0B0',
											fontweight: 600,
											fontSize: '11px',
										}}
									>
										EVENT
									</p>
									<div
										style={{
											flex: 1,
											borderBottom: '0.5px solid #4F4F4F',
											marginLeft: '4px',
											marginRight: '4px',
										}}
									></div>
									<p
										style={{
											color: 'white',
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontSize: '12px',
											width: 'fit-content',
											maxWidth: '200px',
										}}
										title={this.state.eventDetails.name}
									>
										{this.state.eventDetails.name}
									</p>
								</div>
								<div
									style={{
										marginTop: '10px',
										padding: '0px 20px 0px 20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<p
										style={{
											color: '#B0B0B0',
											fontweight: 600,
											fontSize: '11px',
										}}
									>
										DATE
									</p>
									<div
										style={{
											flex: 1,
											borderBottom: '0.5px solid #4F4F4F',
											marginLeft: '4px',
											marginRight: '4px',
										}}
									></div>
									<p
										style={{
											color: 'white',
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontSize: '12px',
											width: 'fit-content',
											maxWidth: '200px',
										}}
										title={moment(
											this.state.eventDetails.date,
											'YYYYMMDD',
										).format('DD MMM YYYY')}
									>
										{moment(this.state.eventDetails.date, 'YYYYMMDD').format(
											'DD MMM YYYY',
										)}
									</p>
								</div>
								<div
									style={{
										marginTop: '10px',
										padding: '0px 20px 0px 20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<p
										style={{
											color: '#B0B0B0',
											fontweight: 600,
											fontSize: '11px',
										}}
									>
										REPORT BY
									</p>
									<div
										style={{
											flex: 1,
											borderBottom: '0.5px solid #4F4F4F',
											marginLeft: '4px',
											marginRight: '4px',
										}}
									></div>
									<p
										style={{
											color: 'white',
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											fontSize: '12px',
											width: 'fit-content',
											maxWidth: '200px',
										}}
										title={this.state.eventDetails.reportingTime}
									>
										{this.state.eventDetails.reportingTime}
									</p>
								</div>
								<div
									style={{
										marginTop: '10px',
										padding: '0px 20px 0px 20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<p
										style={{
											color: '#B0B0B0',
											fontweight: 600,
											fontSize: '11px',
										}}
									>
										CITY
									</p>
									<div
										style={{
											flex: 1,
											borderBottom: '0.5px solid #4F4F4F',
											marginLeft: '4px',
											marginRight: '4px',
										}}
									></div>
									<p
										style={{
											color: 'white',
											fontSize: '12px',
											width: 'fit-content',
											maxWidth: '200px',
										}}
										title={this.state.eventDetails.city}
									>
										{this.state.eventDetails.city}
									</p>
								</div>
								<div
									style={{
										marginTop: '6px',
										padding: '0px 20px 0px 20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<p
										style={{
											color: '#B0B0B0',
											fontweight: 600,
											fontSize: '11px',
										}}
									>
										VENUE
									</p>
									<div
										style={{
											flex: 1,
											borderBottom: '0.5px solid #4F4F4F',
											marginLeft: '4px',
											marginRight: '4px',
										}}
									></div>
									<p
										style={{
											color: 'white',
											fontSize: '12px',
											whiteSpace: 'nowrap',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
											width: 'fit-content',
											maxWidth: '200px',
										}}
										title={
											this.state.eventDetails.venue
												? this.state.eventDetails.venue
												: ''
										}
									>
										{this.state.eventDetails.venue
											? this.state.eventDetails.venue
											: ''}
									</p>
								</div>
								<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
									<p
										style={{
											marginTop: '32px',
											paddingLeft: '20px',
											color: '#B0B0B0',
											fontWeight: 500,
											fontSize: '12px',
											display: 'flex',
											flex: 1,
										}}
									>
										<span>ADDITIONAL SERVICES</span>

										<span
											style={{
												fontSize: '40px',
												color: '#6055EC',
												cursor: 'pointer',
												marginTop: '-19px',
											}}
											onClick={(e) =>
												this.showShootAddEditModal(
													e,
													this.state.eventDetails.id,
													'additional-service',
												)
											}
										>
											+
										</span>
									</p>
								</div>
								<div
									className="ad-serv-section"
									style={{
										color: 'white',
										paddingLeft: '20px',
										marginTop: '10px',
									}}
								>
									{this.state.eventDetails.additionalServices !== null ? (
										<>
											{this.state.eventDetails.additionalServices.map(
												(el, idx) => {
													return (
														<div
															key={el._id}
															style={{
																marginTop: '8px',
																textTransform: 'capitalize',
																marginLeft: '10px',
																fontSize: '11px',
															}}
														>
															<span style={{ color: '#B0B0B0' }}>
																{idx + 1}.
															</span>
															{' ' +
																el.type.charAt(0).toUpperCase() +
																el.type
																	.replace(/([A-Z])/g, ' $1')
																	.slice(1)}
														</div>
													);
												},
											)}
										</>
									) : (
										<div
											style={{
												marginTop: '8px',
												marginLeft: '10px',
												fontSize: '11px',
											}}
										>
											No Services yet
										</div>
									)}
								</div>
							</div>
							<div
								style={{
									height: '60vh',
									maxHeght: '60vh',
									overflowY: 'scroll',
								}}
							>
								<div
									style={{
										marginTop: '20px',
										display: 'flex',
										justifyContent: 'space-between',
										alignItems: 'center',
									}}
								>
									<div style={{ display: 'flex', alignItems: 'center' }}>
										<span
											style={{
												paddingLeft: '20px',
												color: '#B0B0B0',
												fontWeight: 500,
												fontSize: '12px',
												display: 'flex',
												flex: 1,
											}}
										>
											CREW
										</span>
										<p
											style={{
												fontSize: '40px',
												color: '#6055EC',
												cursor: 'pointer',
												marginTop: '-7px',
											}}
											onClick={(e) =>
												this.showShootAddEditModal(
													e,
													this.state.eventDetails.id,
													'crew',
												)
											}
										>
											+
										</p>
									</div>
									<span
										onClick={(e) =>
											window.open(
												`https://pdf.huemn.com/shoot-crew/${this.props.params.vendorID}/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
											)
										}
										style={{
											cursor: 'pointer',
										}}
									>
										<DownloadIcon />
									</span>
								</div>
								<p
									style={{
										marginTop: '20px',
										paddingLeft: '20px',
										color: '#B0B0B0',
										fontWeight: 500,
										fontSize: '12px',
									}}
								>
									CANDID PHOTO
								</p>
								<div
									className="ad-serv-section"
									style={{
										color: 'white',
										paddingLeft: '20px',
										marginTop: '10px',
									}}
								>
									{this.getAllCrewNames('photographer', 'candid') !== '-' ? (
										this.getAllCrewNames('photographer', 'candid')
											.split(',')
											.map((el, idx) => {
												return (
													<div
														style={{
															marginTop: '8px',
															marginLeft: '10px',
															fontSize: '11px',
														}}
														key={`photographer-candid${idx}`}
													>
														<span
															style={{
																color: '#B0B0B0',
															}}
														>
															{idx + 1}.
														</span>
														{' ' + el}
													</div>
												);
											})
									) : (
										<div
											style={{
												marginTop: '8px',
												marginLeft: '10px',
												fontSize: '11px',
											}}
										>
											No Candid Photographers yet
										</div>
									)}
								</div>
								<p
									style={{
										marginTop: '32px',
										paddingLeft: '20px',
										color: '#B0B0B0',
										fontWeight: 500,
										fontSize: '12px',
									}}
								>
									TRADITIONAL PHOTO
								</p>
								<div
									className="ad-serv-section"
									style={{
										color: 'white',
										paddingLeft: '20px',
										marginTop: '10px',
										fontSize: '11px',
										// display: 'flex',
										// flexDirection: 'columm',
									}}
								>
									{this.getAllCrewNames('photographer', 'traditional') !== '-' ? (
										this.getAllCrewNames('photographer', 'traditional')
											.split(',')
											.map((el, idx) => {
												return (
													<div
														style={{
															marginTop: '8px',
															marginLeft: '10px',
														}}
														key={`photographer-traditional${idx}`}
													>
														<span style={{ color: '#B0B0B0' }}>
															{idx + 1}.
														</span>
														{' ' + el}
													</div>
												);
											})
									) : (
										<div
											style={{
												marginTop: '8px',
												marginLeft: '10px',
											}}
										>
											No Traditional Photographers yet
										</div>
									)}
								</div>
								<p
									style={{
										marginTop: '32px',
										paddingLeft: '20px',
										color: '#B0B0B0',
										fontWeight: 500,
										fontSize: '11px',
									}}
								>
									CANDID VIDEO
								</p>
								<div
									className="ad-serv-section"
									style={{
										color: 'white',
										paddingLeft: '20px',
										marginTop: '10px',
									}}
								>
									{this.getAllCrewNames('cinematographer', 'candid') !== '-' ? (
										this.getAllCrewNames('cinematographer', 'candid')
											.split(',')
											.map((el, idx) => {
												return (
													<div
														style={{
															marginTop: '8px',
															marginLeft: '10px',
															fontSize: '11px',
														}}
														key={`cinematographer-candid${idx}`}
													>
														<span style={{ color: '#B0B0B0' }}>
															{idx + 1}.
														</span>
														{' ' + el}
													</div>
												);
											})
									) : (
										<div
											style={{
												marginTop: '8px',
												marginLeft: '10px',
												fontSize: '11px',
											}}
										>
											No Candid Videographers yet
										</div>
									)}
								</div>

								<p
									style={{
										marginTop: '32px',
										paddingLeft: '20px',
										color: '#B0B0B0',
										fontWeight: 500,
										fontSize: '12px',
									}}
								>
									TRADITIONAL VIDEO
								</p>
								<div
									className="ad-serv-section"
									style={{
										color: 'white',
										paddingLeft: '20px',
										marginTop: '10px',
									}}
								>
									{this.getAllCrewNames('cinematographer', 'traditional') !==
									'-' ? (
										this.getAllCrewNames('cinematographer', 'traditional')
											.split(',')
											.map((el, idx) => {
												return (
													<div
														key={`cinematographer-traditional${idx}`}
														style={{
															marginTop: '8px',
															marginLeft: '10px',
															fontSize: '11px',
														}}
													>
														<span style={{ color: '#B0B0B0' }}>
															{idx + 1}.
														</span>
														{' ' + el}
													</div>
												);
											})
									) : (
										<div
											style={{
												marginTop: '8px',
												marginLeft: '10px',
												fontSize: '11px',
											}}
										>
											No Traditional Videographers yet
										</div>
									)}
								</div>
							</div>
						</div>

						<div
							className="memory-card-equipment-section"
							style={{
								width: '50vw',
								display: 'flex',
								flexDirection: 'column',
								gap: '40px',
								// justifyContent: 'center',

								// backgroundColor: 'red',
								// height: '100vh',
								maxHeight: '100vh',
								borderLeft: '1px solid #3F3F3E',
								borderRight: '1px solid #3F3F3E',
								// padding: '30px',
							}}
						>
							<div style={{ height: '50vh' }}>
								<div className="busy-modal" style={{ width: '48vw' }}>
									<div className="bm-header3">
										<div
											style={{
												// padding: '20px 0',
												display: 'flex',
												flexDirection: 'column',
												gap: '10px',
												width: '100%',
											}}
										>
											<div
												style={{
													padding: '12px',
													paddingBottom: '0px',
													width: '100%',
													display: 'flex',
													color: 'white',
													alignItems: 'center',
													// gap: '32vw',
													justifyContent: 'space-between',

													// gap: '40vw',
												}}
											>
												<p style={{ fontSize: '14px' }}>
													MEMORY CARDS (
													{this.state.eventDetails.memoryCards
														? this.state.eventDetails.memoryCards.length
														: '0'}
													)
												</p>
												<div
													style={{
														disply: 'flex',
														alignItems: 'center',
														gap: '10px',
													}}
												>
													<FullScreen
														style={{
															height: '20px',
															width: '20px',
															marginRight: '15px',
															cursor: 'pointer',
														}}
														onClick={() => {
															this.onExpandClick();
														}}
													/>
													<DownloadIcon
														style={{
															height: '20px',
															width: '20px',
															marginRight: '15px',
															cursor: 'pointer',
														}}
														onClick={(e) =>
															window.open(
																`https://pdf.huemn.com/memory-cards/${this.props.params.vendorID}/${this.props.params.workspaceID}/${this.props.params.projectID}/${this.props.params.shootID}`,
															)
														}
													/>
													<span
														onClick={(e) =>
															this.toggleMemoryCardDropDown(e)
														}
														ref={this.memoryCardRef}
													>
														<MoreIconNew
															style={{
																height: '20px',
																width: '20px',
																cursor: 'pointer',
															}}
														/>
													</span>
												</div>
											</div>
											<div
												className="shoot-page-sub-header-container2"
												style={{
													width: '100%',
													padding: '0px 12px ',
													display: 'flex',
													alignItems: 'center',
													gap: '10px',
													fontSize: '14px',
													flexWrap: 'wrap',
													zIndex: 1,
													// backgroundColor: 'none',
												}}
											>
												<div
													className={
														'sub-filter-item' +
														(this.state.mcCurrFilter === 'All'
															? ' active'
															: '')
													}
													// style={{
													// 	padding: '8px 12px ',
													// 	borderRadius: '30px',
													// 	backgroundColor: '#6055EC',
													// 	color: 'white',
													// 		cursor: 'pointer',

													// }}
													onClick={() => {
														if (this.state.mcCurrFilter !== 'All') {
															this.mcOnChangeFIlter('All');
														}
													}}
												>
													All{' '}
													{this.state.eventDetails.memoryCards
														? this.state.eventDetails.memoryCards.length
														: '0'}
												</div>
												{this.getReceivedCount() > 0 ? (
													<div
														// style={{
														// 	padding: '8px 12px ',
														// 	borderRadius: '30px',
														// 	backgroundColor: '#1C1C1C',
														// 	color: '#CA5A4F',
														// 	cursor: 'pointer',
														// }}
														style={{
															color: '#CA5A4F',
														}}
														className={
															'sub-filter-item' +
															(this.state.mcCurrFilter ===
															'notReceived'
																? ' active'
																: '')
														}
														onClick={() => {
															if (
																this.state.mcCurrFilter !==
																'notReceived'
															) {
																this.mcOnChangeFIlter(
																	'notReceived',
																);
															}
														}}
														// onClick={() => {
														// 	this.state.eventDetails.memoryCards = _.filter(this.state.eventDetails.memoryCards,{isReceived:false})
														// }}
													>
														Not Received {this.getNotReceivedCount()}
													</div>
												) : (
													<></>
												)}
												{_.map(
													_.groupBy(
														_.sortBy(
															this.state.eventDetails.memoryCards,
															['isReceived'],
														),
														'userId',
													),
													(item, userId) => {
														return (
															<div
																// className={
																// 	'sub-filter-item' +
																// 	(this.state.mcCurrFilter ===
																// 	userId
																// 		? ' active'
																// 		: '')
																// }
																// style={{
																// 	padding: '8px 12px ',
																// 	borderRadius: '30px',
																// 	backgroundColor: '#1C1C1C',
																// 	color: '#B0B0B0',
																// 	cursor: 'pointer',
																// }}
																key={`${userId}`}
																className={
																	'sub-filter-item' +
																	(this.state.mcCurrFilter ===
																	userId
																		? ' active'
																		: '')
																}
																onClick={() => {
																	if (
																		this.state.mcCurrFilter !==
																		userId
																	) {
																		this.mcOnChangeFIlter(
																			userId,
																		);
																	}
																}}
															>
																<span className="title">
																	{_.size(
																		_.filter(
																			this.state
																				.tenantUsersList,
																			{
																				id: userId,
																			},
																		),
																	) > 0
																		? _.has(
																				_.filter(
																					this.state
																						.tenantUsersList,
																					{
																						id: userId,
																					},
																				)[0],
																				'displayName',
																		  ) &&
																		  _.filter(
																				this.state
																					.tenantUsersList,
																				{
																					id: userId,
																				},
																		  )[0]['displayName'] !=
																				null
																			? _.filter(
																					this.state
																						.tenantUsersList,
																					{
																						id: userId,
																					},
																			  )[0]['displayName']
																			: _.filter(
																					this.state
																						.tenantUsersList,
																					{
																						id: userId,
																					},
																			  )[0].firstName +
																			  ' ' +
																			  _.filter(
																					this.state
																						.tenantUsersList,
																					{
																						id: userId,
																					},
																			  )[0].lastName
																		: ''}
																	{'  ' +
																		_.size(
																			_.filter(
																				this.state
																					.eventDetails
																					.memoryCards,
																				{
																					userId: userId,
																					isReceived: true,
																				},
																			),
																		)}
																	/{_.size(item)}
																</span>
																{/* <span className="title">
																	{_.size(item)}
																</span> */}
															</div>
														);
													},
												)}
												<></>
											</div>
										</div>
									</div>
									<div
										style={{
											maxHeight: '30vh',
											overflowY: 'scroll',
										}}
									>
										<table
											className="memoryCardSumaryTable3"
											style={{
												borderLeft: '0.5px solid  #383838',
												borderTop: '0.5px solid  #383838',
												color: 'white',
												width: '48vw',
											}}
										>
											<thead
												style={{
													position: 'sticky',
													top: '0px',
													/* make the table heads sticky */
												}}
											>
												<tr>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '80px',
														}}
													>
														S. NO
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														CARD TYPE
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														QR CODE
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														ASSIGNED TO
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '80px',
														}}
													>
														RECEIVED
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '120px',
														}}
													>
														DATA IN GB
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '80px',
														}}
													>
														COPIES
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '80px',
														}}
													>
														VERIFIED
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														STATUS
													</th>
												</tr>
											</thead>
											<tbody>
												{this.state.eventDetails.memoryCards &&
													_.map(
														this.state.mcCurrFilter === 'All'
															? _.sortBy(
																	this.state.eventDetails
																		.memoryCards,
																	[
																		'isReceived',
																		'status',
																		'isEmpty',
																	],
															  )
															: this.state.mcCurrFilter ===
															  'notReceived'
															? _.filter(
																	_.sortBy(
																		this.state.eventDetails
																			.memoryCards,
																		[
																			'isReceived',
																			'status',
																			'isEmpty',
																		],
																	),
																	{
																		isReceived: false,
																	},
															  )
															: _.filter(
																	_.sortBy(
																		this.state.eventDetails
																			.memoryCards,
																		[
																			'isReceived',
																			'status',
																			'isEmpty',
																		],
																	),
																	{
																		userId: this.state
																			.mcCurrFilter,
																	},
															  ),

														(el, idx) => {
															return (
																<tr
																	key={idx}
																	onClick={() => {
																		if (
																			el.isRemapped !== true
																		) {
																			if (
																				el.isReceived ==
																					true &&
																				_.has(
																					el,
																					'isRemapped',
																				) &&
																				(el.isRemapped ===
																					false ||
																					el.isRemapped ===
																						null)
																			) {
																				this.handleOnCLickMC(
																					el,
																				);
																			}
																		}
																	}}
																	style={{
																		cursor: el.isRemapped
																			? ''
																			: 'pointer',
																	}}
																>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',

																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{idx + 1}
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',

																			// width: '400px',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.type} ({el.size})
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',

																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.qrCode}
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',

																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.userName}
																	</td>

																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.isRemapped ? (
																			<RemapIcon />
																		) : el.isReceived ? (
																			<TickIcon
																				style={{
																					height: '20px',
																					width: '20px',
																				}}
																			/>
																		) : _.size(
																				_.filter(
																					this.state
																						.eventDetails
																						.memoryCards,
																					{
																						isReceived: true,
																					},
																				),
																		  ) > 0 ? (
																			<CrossIcon2
																				style={
																					{
																						// height: '35px',
																						// width: '35px',
																					}
																				}
																			/>
																		) : (
																			<CrossIcon
																				style={{
																					height: '35px',
																					width: '35px',
																				}}
																			/>
																		)}
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',
																			// textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.isEmpty
																			? 'Empty'
																			: el.backupLogs &&
																			  el.backupLogs.length >
																					0
																			? el.backupLogs[0]
																					?.backupSize +
																			  ' GB'
																			: ''}
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.isRemapped
																			? ''
																			: el.backupLogs &&
																			  _.size(
																					el.backupLogs,
																			  ) > 0
																			? _.size(el.backupLogs)
																			: ''}
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{!el.isReceived ? (
																			'-'
																		) : this.isVerfiedResult(
																				el.backupLogs,
																		  ) === true ? (
																			<TickIcon
																				style={{
																					height: '20px',
																					width: '20px',
																				}}
																			/>
																		) : (
																			<CrossIcon3
																				style={
																					{
																						// height: '30px',
																						// width: '30px',
																					}
																				}
																			/>
																		)}
																	</td>
																	<td
																		style={{
																			textDecoration:
																				el.isRemapped
																					? 'line-through'
																					: '',
																			color: el.isRemapped
																				? '#707070'
																				: '',
																			// textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						this.state
																							.eventDetails
																							.memoryCards,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.isRemapped
																			? 'Reassigned'
																			: el.subStatus === null
																			? '-'
																			: el.subStatus ===
																					'ready' &&
																			  el.isReceived === true
																			? 'Released'
																			: el?.subStatus
																					.charAt(0)
																					.toUpperCase() +
																			  el?.subStatus
																					.replace(
																						/([A-Z])/g,
																						' $1',
																					)
																					.slice(1)}
																	</td>
																</tr>
															);
														},
													)}
											</tbody>
										</table>
									</div>
								</div>
							</div>
							{this.state.showMemoryCardDropdown ? (
								<div
									className=""
									style={{
										display: 'flex',
										flexDirection: 'column',
										// alignItems: 'center',
										width: '259px',
										padding: '15px',
										backgroundColor: 'white',
										color: 'black',
										borderRadius: '8px',
										// width: 'auto',
										fontWeight: '500',
										gap: '20px',
										position: 'absolute',
										zIndex: '999999',
										marginBottom: '40vh',
										marginLeft: '38vw',
									}}
									ref={this.memoryCardDropdownRef}
								>
									<a
										style={{
											cursor: 'pointer',
										}}
										onClick={(e) => this.showMemoryCardAssignModal(e)}
									>
										Assign Memory Cards
									</a>
									<a
										style={{
											cursor: 'pointer',
										}}
										onClick={(e) => this.showMemoryCardReceiveModal(e)}
									>
										Receive Memory Cards
									</a>
									<a
										style={{
											cursor: 'pointer',
										}}
										onClick={(e) => this.showRecordABackUpModal(e)}
									>
										Record a Backup
									</a>
									{false &&
									_.size(
										_.filter(this.state.eventDetails.memoryCards, {
											isReceived: false,
										}),
									) > 0 ? (
										<a
											style={{
												cursor: 'pointer',
											}}
											onClick={() => this.showReAssignMemoryCards()}
										>
											Reassign Memory Cards
										</a>
									) : null}
								</div>
							) : (
								''
							)}
							<div style={{ height: '50vh', maxHeight: '50vw' }}>
								<div
									className="busy-modal"
									style={{ width: '48vw', marginTop: '10px' }}
								>
									<div className="bm-header3">
										<div
											style={{
												// padding: '20px 0',
												display: 'flex',
												flexDirection: 'column',
												gap: '10px',
												width: '100%',
											}}
										>
											<div
												style={{
													padding: '0px 12px',
													paddingBottom: '0px',
													width: '100%',
													display: 'flex',
													color: 'white',
													alignItems: 'center',
													// gap: '32vw',
													justifyContent: 'space-between',
													// gap: '40vw',
												}}
											>
												<p style={{ fontSize: '14px' }}>
													EQUIPMENTS (
													{equipmentsList ? equipmentsList.length : '0'})
												</p>
												<div
													style={{
														disply: 'flex',
														alignItems: 'center',
														gap: '10px',
													}}
												>
													<FullScreen
														style={{
															height: '20px',
															width: '20px',
															marginRight: '15px',
															cursor: 'pointer',
														}}
														onClick={() => {
															this.onExpandClick2();
														}}
													/>
													<DownloadIcon
														style={{
															height: '20px',
															width: '20px',
															marginRight: '15px',
															cursor: 'pointer',
														}}
														onClick={(e) =>
															window.open(
																`https://pdf.huemn.com/equipment/${
																	this.props.params.vendorID
																}/${
																	this.props.params.workspaceID
																}/${this.props.params.projectID}/${
																	this.props.params.shootID
																}${
																	this.state.eqCurrFilter == 'All'
																		? ''
																		: '?assignedTo=' +
																		  this.state.eqCurrFilter
																}`,
															)
														}
													/>
													<span
														onClick={(e) =>
															this.toggleEquipmentDropDown(e)
														}
														ref={this.equipmentRef}
													>
														<MoreIconNew
															style={{
																height: '20px',
																width: '20px',
																cursor: 'pointer',
															}}
														/>
													</span>
												</div>
											</div>
											<div
												className="shoot-page-sub-header-container2"
												style={{
													padding: '12px',
													width: '100%',
													display: 'flex',
													alignItems: 'center',
													gap: '10px',
													fontSize: '14px',
													flexWrap: 'wrap',
												}}
											>
												<p
													className={
														'sub-filter-item' +
														(this.state.eqCurrFilter === 'All'
															? ' active'
															: '')
													}
													// style={{
													// 	padding: '8px 12px ',
													// 	borderRadius: '30px',
													// 	backgroundColor: '#6055EC',
													// 	color: 'white',
													// 	cursor: 'pointer',
													// }}
													onClick={() => {
														if (this.state.eqCurrFilter !== 'All') {
															this.eqOnChangeFIlter('All');
														}
													}}
												>
													All{' '}
													{equipmentsList ? equipmentsList.length : '0'}
												</p>
												{this.getReceivedCount2(equipmentsList) > 0 ? (
													<div
														className={
															'sub-filter-item' +
															(this.state.eqCurrFilter ===
															'notReceived'
																? ' active'
																: '')
														}
														style={{
															// padding: '8px 12px ',
															// borderRadius: '30px',
															// backgroundColor: '#1C1C1C',
															color: '#CA5A4F',

															// cursor: 'pointer',
														}}
														onClick={() => {
															if (
																this.state.eqCurrFilter !==
																'notReceived'
															) {
																this.eqOnChangeFIlter(
																	'notReceived',
																);
															}
														}}
													>
														Not Received{' '}
														{this.getNotReceivedCount2(equipmentsList)}
													</div>
												) : (
													<></>
												)}

												{/* {this.getAllAssignedToNames2().map((el) => {
													return (
														<>
															<p
																style={{
																	padding: '8px 12px ',
																	borderRadius: '30px',
																	backgroundColor: '#1C1C1C',
																	color: '#B0B0B0',
																}}
															>
																{el.name} {el.rc}/{el.tc}
															</p>
														</>
													);
												})} */}
												{_.map(
													_.groupBy(
														_.sortBy(equipmentsList, ['isReceived']),
														'userId',
													),
													(item, userId) => {
														return (
															<div
																key={userId}
																className={
																	'sub-filter-item' +
																	(this.state.eqCurrFilter ===
																	userId
																		? ' active'
																		: '')
																}
																// style={{
																// 	padding: '8px 12px ',
																// 	borderRadius: '30px',
																// 	backgroundColor: '#1C1C1C',
																// 	color: '#B0B0B0',
																// 	cursor: 'pointer',
																// }}
																// className={
																// 	'sub-filter-item' +
																// 	(this.state.eqCurrFilter ===
																// 	userId
																// 		? ' active'
																// 		: '')
																// }
																onClick={() => {
																	if (
																		this.state.eqCurrFilter !==
																		userId
																	) {
																		this.eqOnChangeFIlter(
																			userId,
																		);
																	}
																}}
															>
																<span className="title">
																	{_.size(
																		_.filter(
																			this.state
																				.tenantUsersList,
																			{
																				id: userId,
																			},
																		),
																	) > 0
																		? _.filter(
																				this.state
																					.tenantUsersList,
																				{
																					id: userId,
																				},
																		  )[0].firstName +
																		  ' ' +
																		  _.filter(
																				this.state
																					.tenantUsersList,
																				{
																					id: userId,
																				},
																		  )[0].lastName
																		: ''}
																</span>
																<span className="title">
																	{' ' +
																		_.size(
																			_.filter(
																				equipmentsList,
																				{
																					userId: userId,
																					isReceived: true,
																				},
																			),
																		)}
																	/{_.size(item)}
																</span>
															</div>
														);
													},
												)}
											</div>

											{this.state.eventDetails.equipments ? (
												<div
													className="shoot-page-sub-header-container2"
													style={{
														padding: '12px',
														width: '100%',
														display: 'flex',
														alignItems: 'center',
														gap: '10px',
														fontSize: '14px',
														flexWrap: 'wrap',
													}}
												>
													{_.map(
														_.groupBy(
															this.state.eventDetails.equipments.filter(
																(item12) =>
																	item12.hasOwnProperty('eqId'),
															),
															(item) =>
																item.branch
																	? item.branch.branchId
																	: 'No Branch',
														),

														(item, userId) => {
															return (
																<div className={'sub-filter-item'}>
																	<span className="title">
																		{userId}
																	</span>
																	<span className="title">
																		{' ' +
																			_.size(
																				_.filter(
																					this.state
																						.eventDetails
																						.equipments,
																					{
																						branch:
																							userId ===
																							'No Branch'
																								? null
																								: {
																										branchId:
																											userId,
																								  },
																						isReceived: true,
																					},
																				),
																			)}
																		/{_.size(item)}
																	</span>
																</div>
															);
														},
													)}
												</div>
											) : (
												''
											)}
										</div>
									</div>
									<div
										style={{
											maxHeight: '30vh',
											overflowY: 'scroll',
										}}
									>
										<table
											className="memoryCardSumaryTable3"
											style={{
												borderLeft: '0.5px solid  #383838',
												borderTop: '0.5px solid  #383838',
												color: 'white',
												width: '48vw',
											}}
										>
											<thead
												style={{
													position: 'sticky',
													top: '0px',
												}}
											>
												<tr>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '80px',
														}}
													>
														S. NO
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '300px',
														}}
													>
														DESCRIPTION
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														SERIAL NO.
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '80px',
														}}
													>
														BRANCH ID
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														QR CODE
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														ASSIGNED TO
													</th>
													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														RECEIVED
													</th>

													<th
														style={{
															color: '#B0B0B0',
															minWidth: '180px',
														}}
													>
														STATUS
													</th>
												</tr>
											</thead>

											{/* equipments */}
											<tbody>
												{equipmentsList &&
													_.map(
														this.state.eqCurrFilter === 'All'
															? _.orderBy(
																	equipmentsList,
																	'isReceived',
															  )
															: this.state.eqCurrFilter ===
															  'notReceived'
															? _.filter(
																	_.orderBy(
																		equipmentsList,
																		'isReceived',
																	),
																	{
																		isReceived: false,
																	},
															  )
															: _.filter(
																	_.orderBy(
																		equipmentsList,
																		'isReceived',
																	),
																	{
																		userId: this.state
																			.eqCurrFilter,
																	},
															  ),
														(el, idx) => {
															return (
																<tr key={idx}>
																	<td
																		style={{
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{idx + 1}
																	</td>
																	<td
																		style={{
																			// textAlign: 'center',
																			// marginLeft: '10px',
																			paddingLeft: '10px',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.description}
																	</td>
																	<td
																		style={{
																			// textAlign: 'center',
																			paddingLeft: '10px',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.manufacturerId}
																	</td>
																	<td
																		style={{
																			// textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.branch?.branchId || ''}
																	</td>
																	<td
																		style={{
																			// textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.qrCode}
																	</td>

																	<td
																		style={{
																			// textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.userName}
																	</td>
																	<td
																		style={{
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.isReceived ? (
																			<TickIcon
																				style={{
																					height: '20px',
																					width: '20px',
																				}}
																			/>
																		) : _.size(
																				_.filter(
																					equipmentsList,
																					{
																						isReceived: true,
																					},
																				),
																		  ) > 0 ? (
																			<CrossIcon2
																				style={
																					{
																						// height: '35px',
																						// width: '35px',
																					}
																				}
																			/>
																		) : (
																			<CrossIcon
																				style={{
																					height: '35px',
																					width: '35px',
																				}}
																			/>
																		)}
																	</td>
																	<td
																		style={{
																			textAlign: 'center',
																			backgroundColor:
																				!el.isReceived &&
																				_.size(
																					_.filter(
																						equipmentsList,
																						{
																							isReceived: true,
																						},
																					),
																				) > 0
																					? '#7A2915'
																					: '#121212',
																		}}
																	>
																		{el.status === 'ready'
																			? 'Received'
																			: 'Not Received'}
																	</td>
																</tr>
															);
														},
													)}
											</tbody>
										</table>
									</div>
								</div>
							</div>
							{this.state.showEquimentDropdown ? (
								<div
									className=""
									style={{
										display: 'flex',
										flexDirection: 'column',
										// alignItems: 'center',
										padding: '15px',
										backgroundColor: 'white',
										color: 'black',
										borderRadius: '8px',
										// width: 'auto',
										width: '259px',
										fontWeight: '500',
										gap: '15px',
										position: 'absolute',
										zIndex: '999999',
										marginTop: '50vh',
										marginLeft: '38vw',
									}}
									ref={this.equipmentDropdownRef}
								>
									<a
										style={{
											cursor: 'pointer',
										}}
										onClick={(e) => this.showEquimentAssignModal(e)}
									>
										Assign Equipments
									</a>
									<a
										style={{
											cursor: 'pointer',
										}}
										onClick={(e) => this.showEquimentReceiveModal(e)}
									>
										Receive Equipments
									</a>
									{/* <a
										style={{
											cursor: 'pointer',
										}}
										onClick={(e) => this.showReAssignEquipments(e)}
									>
										Re-assign Equipments
									</a> */}
								</div>
							) : (
								''
							)}
						</div>
						<div
							className="hard-drive-expenses-section"
							style={{
								display: 'flex',
								flexDirection: 'column',
								// padding: '20px',
								gap: '15px',
								height: '100vh',
								maxHeight: '100vh',
								overflowY: 'scroll',
								width: '19vw',
							}}
						>
							<div
								style={{
									// height: '30vh',
									// padding: '20px',
									padding: '20px',
								}}
							>
								<p style={{ color: '#B0B0B0', fontSize: '14px', fontweight: 600 }}>
									HARD DRIVES (
									{this.state.eventDetails.hardDrives
										? this.state.eventDetails.hardDrives.length
										: '0'}
									)
								</p>
								{this.state.eventDetails.hardDrives ? (
									<>
										{this.state.eventDetails.hardDrives.map((el) => {
											return (
												<div
													key={el._id}
													style={{
														display: 'flex',
														alignItems: 'center',
														justifyContent: 'space-between',
														// gap: '80px',
														color: 'white',
														marginTop: '20px',
														cursor: 'pointer',
													}}
													onClick={() => this.handleOnClickHDD(el)}
												>
													<span
														className={`completed-shoots `}
														style={{
															display: 'flex',
															alignItems: 'center',
															textTransform: 'uppercase',
															fontSize: '11px',
														}}
													>
														<b
															style={{
																width: '10px',
																height: '10px',
																minHeight: '10px',
																minWidth: '10px',
																borderRadius: '2px',
																backgroundColor:
																	el.category === 'working'
																		? '#03A0FF'
																		: el.category === 'backup'
																		? '#FE2C2B'
																		: '#7B7B7B',
																marginRight: 5,
																display: 'flex',
															}}
														></b>
														{el.category === 'working'
															? 'WORKING '
															: el.category === 'backup'
															? 'BACKUP '
															: 'SECURE '}
														({el.qrCode}) ({el.size}TB)
													</span>
													<p>
														{el.responsibleUser
															? el.responsibleUser
															: ''}
													</p>
												</div>
											);
										})}
									</>
								) : (
									<></>
								)}
							</div>
							<div
								style={{
									padding: '20px 20px 0 20px',
									width: '100%',
								}}
							>
								<p
									style={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px',
									}}
								>
									<p
										style={{
											fontSize: '14px',
											color: '#B0B0B0',
										}}
									>
										EXPENSES ({this.getTotalExpenseAmount()}){' '}
									</p>

									<p
										style={{
											fontSize: '40px',
											color: '#6055EC',
											cursor: 'pointer',
											marginTop: '-10px',
										}}
										onClick={(e) => this.showAddEditExpenseModal(e)}
									>
										+
									</p>
								</p>
							</div>
							{_.map(_.groupBy(this.state.expensesList, 'spentBy'), (user, key) => {
								return (
									<div className="shoot-summary-right-main-item-container">
										{_.map(user, (expense, index) => {
											if (index === 0) {
												return (
													<>
														<div className="shoot-summary-item-header-container">
															<div className="shoot-summary-item-title">
																{
																	_.find(
																		this.state
																			.assignedToFilters,
																		{ key: expense.spentBy },
																	)?.name
																}
															</div>
															<span className="shoot-summary-total-text">
																Total
															</span>
															<span className="shoot-summary-horizontal-bar"></span>
															<span className="shoot-summary-amount-text">
																{this.formatCurrency(
																	'inr',
																	_.reduce(
																		user,
																		(sum, expense) => {
																			if (
																				isNaN(
																					expense.amount,
																				)
																			) {
																			} else {
																				return (
																					sum +
																					parseInt(
																						expense.amount,
																					)
																				);
																			}
																		},
																		0,
																	),
																)}
															</span>
															<span className="dummy-div-circle"></span>
														</div>
														<div
															className="shoot-summary-item-body-container"
															onClick={(e) =>
																this.showAddEditExpenseModal(
																	e,
																	expense.id,
																)
															}
														>
															<div className="shoot-summary-title-text">
																{_.capitalize(expense.type)}
															</div>
															<span className="shoot-summary-horizontal-bar"></span>
															<span className="shoot-summary-amount-text">
																{this.formatCurrency(
																	'inr',
																	expense.amount,
																)}
															</span>
															<span
																className={
																	'shoot-summary-circle-status' +
																	(expense.isApproved === true
																		? ' approved'
																		: expense.isRejected ===
																		  true
																		? ' rejected'
																		: expense.isDeleted === true
																		? ' deleted'
																		: ' pending')
																}
															></span>
														</div>
													</>
												);
											} else {
												return (
													<div
														className="shoot-summary-item-body-container"
														onClick={(e) =>
															this.showAddEditExpenseModal(
																e,
																expense.id,
															)
														}
													>
														<div className="shoot-summary-title-text">
															{_.capitalize(expense.type)}
														</div>
														<span className="shoot-summary-horizontal-bar"></span>
														<span className="shoot-summary-amount-text">
															{this.formatCurrency(
																'inr',
																expense.amount,
															)}
														</span>
														<span
															className={
																'shoot-summary-circle-status' +
																(expense.isApproved === true
																	? ' approved'
																	: expense.isRejected === true
																	? ' rejected'
																	: expense.isDeleted === true
																	? ' deleted'
																	: ' pending')
															}
														></span>
													</div>
												);
											}
										})}
									</div>
								);
							})}

							{/* <div className="shoot-summary-right-main-table">
								<table>
									<thead>
										<tr>
											<th>BOOKING ID</th>
											<th>TRAVEL DATE</th>
											<th>STATUS</th>
										</tr>
									</thead>
									<tbody>
										{_.map(this.state.expensesList, (expense, index) => {
											if (_.size(expense.metaData) === 0) {
												return null;
											}
											return (
												<tr
													onClick={(e) =>
														this.showAddEditExpenseModal(e, expense.id)
													}
												>
													<td>{expense.metaData.bookingID}</td>
													<td>
														{moment(
															expense.metaData.travelDate,
															'YYYYMMDD',
														).format('DD MMM YYYY')}
													</td>
													<td>{_.capitalize(expense.metaData.status)}</td>
												</tr>
											);
										})}
									</tbody>
								</table>
							</div> */}
						</div>

						{this.state.showEventModal ? (
							<MCTableFullScreen
								eventDetails={this.state.eventDetails}
								custClass={'modal-with-no-fixed-height'}
								handleClose={() => this.toggleModal()}
								show={this.state.showEventModal}
								mcCurrFilter={this.state.mcCurrFilter}
								tenantUsersList={this.state.tenantUsersList}
								handleOnCLickMC={(el) => this.handleOnCLickMC(el)}
								mcOnChangeFIlter={(userId) => this.mcOnChangeFIlter(userId)}
								showReAssignMemoryCards={this.showReAssignMemoryCards}
								showRecordABackUpModal={this.showRecordABackUpModal}
							/>
						) : (
							''
						)}
						<EqTableFullScreen
							eventDetails={this.state.eventDetails}
							custClass={'modal-with-no-fixed-height'}
							handleClose={() => this.toggleModal2()}
							show={this.state.showEventModal2}
							tenantUsersList={this.state.tenantUsersList}
							eqCurrFilter={this.state.eqCurrFilter}
							eqOnChangeFIlter={(userId) => this.eqOnChangeFIlter(userId)}
						/>
					</div>
				)}
				{this.state.showReAssignMemoryCards === true ? (
					<ReAssignMemoryCards
						handleClose={(e) => [this.showReAssignMemoryCards()]}
						show={this.state.showReAssignMemoryCards}
						close={(e) => this.showReAssignMemoryCards()}
						memoryCardsList={this.state.eventDetails.memoryCards}
					/>
				) : null}
				{this.state.showRecordABackUpModal === true ? (
					<RecordMemCardBackup
						handleClose={(e) => [this.showRecordABackUpModal()]}
						show={this.state.showRecordABackUpModal}
						close={(e) => this.showRecordABackUpModal()}
						// qrCode={this.state.selectedMC.qrCode}
						// selectedMC={this.state.selectedMC}
						memoryCardsList={this.state.eventDetails.memoryCards}
						onMCBackedUp={() => this.mcDetailsUpdated()}
						recordType={'record'}

						//backupForModal={this.state.backupForModal}
					/>
				) : null}
				{this.state.showRecordMCModal === true ? (
					<RecordMCBackup
						selectedMC={this.state.selectedMC}
						handleClose={(e) => [this.showRecordMCModal(e)]}
						show={this.state.showRecordMCModal}
						close={(e) => this.showRecordMCModal(e)}
						onMCBackedUp={this.mcDetailsUpdated}
						mcDetailsUpdated={this.mcDetailsUpdated}
						hardDrivesList={this.state.eventDetails.hardDrives}
					/>
				) : null}
				{this.state.showAddEditExpenseModal ? (
					<CreateExpense
						handleClose={() => this.showAddEditExpenseModal()}
						show={this.state.showAddEditExpenseModal}
						close={() => this.showAddEditExpenseModal()}
						activeExpenseID={this.state.activeExpenseID}
						projectTitle={this.state.eventDetails.projectTitle}
						tenantId={this.state.eventDetails.tenantId}
						tenantUsersList={this.state.tenantUsersList}
						expenseDetailsUpdated={this.eventDetailsUpdated}
						projectId={this.props.params.projectID}
					/>
				) : (
					''
				)}
				{this.state.showShootAddEditModal === true ? (
					<CreateShoot
						key={this.state.eventDetails.id}
						handleClose={() =>
							this.setState({
								showShootAddEditModal: false,
								shootEditType: null,
							})
						}
						show={this.state.showShootAddEditModal}
						close={() =>
							this.setState({
								showShootAddEditModal: false,
								shootEditType: null,
							})
						}
						data={this.state.eventDetails}
						activeShootID={this.props.params.shootID}
						projectTitle={this.state.eventDetails.projectTitle}
						tenantId={this.state.eventDetails.tenantId}
						tenantUsersList={this.state.tenantUsersList}
						shootDetailsUpdated={(event) => this.eventDetailsUpdated()}
						projectId={this.props.params.projectID}
						isTenantCreate={false} //this.state.selectedProjectID === null}
						workspaceID={this.props.params.workspaceID}
						custClass={'modal-with-no-fixed-height'}
						displayOnly={this.state.shootEditType}
					/>
				) : null}
			</>
		);
	}
}
export default withRouter(NewShoot);
